import React from 'react'
import { Row, Col, Radio, Icon, Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import './RiskCategoryRow.scss'

const RiskCategoryRow = ({ 
  riskKey, 
  category, 
  label, 
  value, 
  onChange, 
  onDelete,
  isVisible
}) => {
  const { t } = useTranslation()

  if (!isVisible) return null

  // Si no hay valor, mostrar "No Posee" en verde
  if (!value) {
    return (
    <Row style={{ display: "flex" }} className="category-risk-row">
      <Col xs={6} className="cell-title category-cell">
        <div style={{ paddingLeft: '20px', color: '#666', fontSize: '12px', display: 'flex', alignItems: 'center' }}>
          <Tooltip title={t('messages.aml.delete') || 'Eliminar'}>
            <Icon 
              type="minus" 
              onClick={() => onDelete(riskKey, category)} 
              style={{ 
                marginRight: '8px', 
                color: 'white', 
                cursor: 'pointer',
                backgroundColor: '#ff4d4f',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(255, 77, 79, 0.3)',
                transition: 'all 0.3s ease',
                flexShrink: 0
              }} 
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#ff7875';
                e.target.style.transform = 'scale(1.1)';
                e.target.style.boxShadow = '0 4px 8px rgba(255, 77, 79, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#ff4d4f';
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 2px 4px rgba(255, 77, 79, 0.3)';
              }}
            />
          </Tooltip>
          {label}
        </div>
      </Col>
      <Col xs={18} className="riesgo-cell risk-category-cell">
        <span style={{ color: '#52c41a', fontWeight: 'bold' }}>
          {t('messages.aml.risk.N') || 'No Posee'}
        </span>
      </Col>
    </Row>
    )
  }

  return (
    <Row style={{ display: "flex" }} className="category-risk-row">
      <Col xs={6} className="cell-title category-cell">
        <div style={{ paddingLeft: '20px', color: '#666', fontSize: '12px', display: 'flex', alignItems: 'center' }}>
          <Tooltip title={t('messages.aml.delete') || 'Eliminar'}>
            <Icon 
              type="minus" 
              onClick={() => onDelete(riskKey, category)} 
              style={{ 
                  marginRight: '8px', 
                  color: 'white', 
                  cursor: 'pointer',
                  backgroundColor: '#ff4d4f',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 4px rgba(255, 77, 79, 0.3)',
                  transition: 'all 0.3s ease',
                  flexShrink: 0
                }} 
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#ff7875';
                  e.target.style.transform = 'scale(1.1)';
                  e.target.style.boxShadow = '0 4px 8px rgba(255, 77, 79, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#ff4d4f';
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 2px 4px rgba(255, 77, 79, 0.3)';
                }}
            />
          </Tooltip>
          {label}
        </div>
      </Col>
      <Col xs={18} className="riesgo-cell risk-category-cell">
        <Radio.Group 
          value={value} 
          onChange={(e) => onChange(riskKey, category, e.target.value)}
        >
          <Radio value='GREEN' />
          <Radio value='YELLOW' />
          <Radio value='ORANGE' />
          <Radio value='RED' />
          <Radio value='BLACK' />
        </Radio.Group>
      </Col>
 
    </Row>
  )
}

export default RiskCategoryRow
